export default "__VITE_ASSET__vaddURjF__"